import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/joy';

import { MissionTool } from '../../stores/MissionStore';
import ChangeBatteryIcon from './icons/ChangeBatteryIcon.svg?react';
import LandIcon from './icons/LandIcon.svg?react';
import OrbitIcon from './icons/OrbitIcon.svg?react';
import PatternIcon from './icons/PatternIcon.svg?react';
import PoiIcon from './icons/PoiIcon.svg?react';
import ReturnToBaseIcon from './icons/ReturnToBaseIcon.svg?react';
import TakeOffIcon from './icons/TakeOffIcon.svg?react';
import WaypointIcon from './icons/WaypointIcon.svg?react';
import ToolButton from './ToolButton';

interface MissionPlanningActionsToolboxProps {
  hasTakeoff?: boolean;
}

const MissionPlanningActionsToolbox: React.FC<MissionPlanningActionsToolboxProps> = ({ hasTakeoff = false }) => {
  const { t } = useTranslation();
  const color = '#F0F4F8';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'column',
        backgroundColor: 'neutral.900'
      }}
    >
      <ToolButton
        tool={MissionTool.TakeOff}
        label={t('mission_planning.takeoff')}
        icon={<TakeOffIcon fill={color} stroke={color} strokeWidth='2' />}
      />
      <ToolButton
        tool={MissionTool.AddWaypoint}
        label={t('mission_planning.waypoint')}
        icon={<WaypointIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.AddPattern}
        label={t('mission_planning.pattern')}
        icon={<PatternIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.AddOrbit}
        label={t('mission_planning.orbit')}
        icon={<OrbitIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.ChangeBattery}
        label={t('mission_planning.change_battery')}
        icon={<ChangeBatteryIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.AddPOI}
        label={t('mission_planning.poi')}
        icon={<PoiIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.ReturnToBase}
        label={t('mission_planning.return_to_base')}
        icon={<ReturnToBaseIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
      <ToolButton
        tool={MissionTool.Land}
        label={t('mission_planning.land')}
        icon={<LandIcon fill={color} stroke={color} strokeWidth='2' />}
        disabled={!hasTakeoff}
      />
    </Box>
  );
};

export default MissionPlanningActionsToolbox;
